export default {
  // 工作台
  workbench: {
    introduction:
      'Visual organization tools that help you manage and monitor project development faster and more accurately',
    addmemo: 'add new memo',
    overdue: 'Time out to-do',
    today: 'To-do today',
    tomorrow: 'Tomorrow want to do',
    later: 'After to-do',
    allToDo: 'All',
    overduenote: 'The deadline is today',
    todaynote: 'The task needs to be finished by today',
    tomorrownote: 'You need to finish the task tomorrow',
    laternote: 'Future tasks',
    taskError: 'Please enter the task name!',
    addschedule: 'Create New Event',
    switchColleagues: 'switch the colleagues',
    soOn: 'so on',
    people: 'people',
    individual: 'individual',
    executor: 'executor',
    endtime: 'set a deadline',
    inputname: 'Please enter a task name',
    leave: 'written request for leave',
    overtime: 'overtime application form',
    memonote1:
      "Today, at the customer's site, the customer put forward his own Suggestions on the quality of the products.",
    memonote2:
      'Sales feedback problem:1. In the customer interface, the priority of the customer shall be marked by color.',
    memonote3:
      'Data analysis statistics are based on comparison and phase data to present the sales performance track, if we do not have...',
    duty_name: 'staff',
    member: 'member name',
    name: 'name',
    visibleMember: 'Members of visible',
    addMember: 'Members of visible',
    modifier: 'modifier',
    edittime: 'modification time',
    status: 'status',
    operation: 'operation',
    disableTip: 'Are you sure you want to disable the workbench?',
    enableTip: 'Are you sure you want to enable the workbench?',
    deleteTip: 'Are you sure you want to delete the workbench?',
    workset: 'Workbench setup',
    workName: 'Workbench name',
    set: 'set',
    pagelayout: 'Page Layout',
    customcomponent: 'Custom Component',
    advancedcomponent: 'Advanced class component',
    last: 'last step',
    next: 'next step',
    namerestriction: 'Workbench names are limited to 12 words',
    workname_empty: 'The workbench name cannot be empty',
    taskShow: 'Task shows',
    showstyle: 'According to the style',
    showT: 'Separate display task',
    showTS: 'Displays tasks and schedules',
    show: 'show',
    tasklist: 'task list',
    view: 'view',
    submenu: 'submenu',
    custommodule: 'Custom module',
    submenuname: 'Submenu name',
    customapp: 'Custom application',
    customapp_empty: 'Custom applications cannot be empty',
    custommodule_empty: 'Custom modules cannot be empty',
    submenu_empty: 'The submenu name cannot be empty',
    name_empty: 'The name cannot be empty',
    chart: 'chart',
    project: 'project',
    allCustomer: 'All the customers',
    szHighSeasPool: 'Shenzhen high seas pool',
    shHighSeasPool: 'Shanghai high seas pool',
    bjHighSeasPool: 'Beijing high seas pool',
    gzHighSeasPool: 'Guangzhou high seas pool',
    ym: 'year,month',
    time: 'time',
    enclosure: 'enclosure',
    remind: 'Remind',
    noRemind: 'None',
    beforeStartTime: 'before starting time',
    participant: 'participant',
    startTime: 'Start & Finish date',
    addAttachment: 'add attachment',
    viewScheduleAssistant: 'Check the schedule assistant',
    startTime_empty: 'Start time cannot be empty',
    endTime_empty: 'The end time cannot be empty',
    time_error: 'The start time must not be greater than or equal to the end time',
    remindTime_empty: 'Remind time cannot be empty',
    fileSize: 'Each attachment size should not exceed 20MB',

    businessprocess: 'business process',
    datalist: 'data list',
    total: 'common',
    a: 'item',
    beginnerboot: 'Novice guide',
    watchvideointroduction: 'Watch the video introduction',
    exploretheteamfaceapp: 'Explore applications',
    createformprocessdataanalysis: 'Create forms/processes/data report',
    invitemembers: 'Invite members',
    guide1:
      '1/4 This is an enterprise data management integration platform system, which is easy to use and easy to get started. The preset fixed modules of the system are ready to use.',
    guide2:
      '2/4 This has a wealth of business and industry applications, one-click installation, immediately achieve your management requirements.',
    guide3:
      '3/4 Want the freedom to create your own proprietary system?Three minutes will take you from 0 to 1 to build a customized system that fits your business needs.',
    guide4:
      '4/4 Want deep customization?This one-on-one customized consultant will be dedicated to serve you ~',
    guide5: '1/4 layout from 0, drag and drop scaffolding, free to define each module.',
    guide6:
      '2/4 The application module can be customized according to different application scenarios of the enterprise, such as reimbursement, leave, application and so on.',
    guide7:
      '3/4 The enterprise process is automatically run by the system and intelligently triggers the planned business steps to achieve efficient work, data visualization, and process fine management.',
    guide8:
      '4/4  According to the actual needs, you can freely define the data type you want to view, data range, presentation style of data statistics report, etc.',
    experienceitnow: 'Experience it now',
    datetimedisplay: 'Date time display',
    headingtext: 'Title Text',
    contenttextclickmoreadddata: 'Content text, click more to add data',
    announcementtitle: 'Announcement title',
    announcementcontenttip:
      'For the content of the announcement, click to add data source on the right',
    today3: 'today',
    overdue2: 'overdue',
    today2: 'today',
    tomorrow2: 'tomorrow',
    later2: 'later',
    completed2: 'Completed',
    seemore: 'See more',
    selectviewrange: 'Select view range',
    unfinished: 'unfinished',
    selectviewer: 'Select viewer',
    allitems: 'All projects',
    calendarview: 'Calendar view',
    teamstatus: 'Team status',
    unknowntime: 'Unknown time',
    contentdeleteTip:
      'This is a piece of content. This is a piece of content. Are you sure you want to delete it?',
    addmembersmanually: 'add members manually',
    individualtasks: 'individual tasks',
    draft: 'draft',

    schedulesharing: 'Agenda Share',
    portalname: 'Portal name',
    schedulesharingsettings: 'Schedule sharing settings',
    schedulesharingsettingsTip:
      'The schedule of a member, department or role can be shared with others by setting, and others can view it through the schedule',
    serialnumber: 'Serial number',
    shareer: 'Sharers',
    shareto: 'Share with',
    newagendasharing: 'New schedule share',
    editportal: 'Edit portal',
    createportal: 'Create portal',
    portalicon: 'Portal icon',
    selecticon: 'Select icon',
    portalnamecannotbeempty: 'Portal name cannot be empty',
    visiblemembercannotbeempty: 'Visible member cannot be empty',
    sharewaremustfill: 'Sharer required',
    sharedtorequired: 'Share to required',
    editingportal: 'Editing portal',
    portalinterfaceconfiguration: 'Portal interface configuration',
    selectbase: 'Select base map',
    nobase: 'No base map',
    basetype: 'Base map type',
    color: 'color',
    uploadimage: 'Upload pictures',
    imagesisrecommende:
      'It is recommended to use 1920 * 1080 or larger pictures, with a limit of 5m',
    addimage: 'Add picture',
    backgroundimagedisplaymode: 'Background image display mode',
    selectcolor: 'Choose a color',
    restoredefault: 'Restore default',
    selectouterbox: 'Choose frame',
    title: 'title',
    headingfont: 'Title font',
    titlebackground: 'Title Background',
    background: 'background',
    backgroundsettings: 'Background settings',
    frame: 'frame',
    outsidebox: 'Column outline',
    layout: 'layout',
    selectlayout: 'Select layout',
    component: 'component',
    theme: 'theme',
    transparenttheme: 'Transparent theme',
    freelayout: 'Free layout',
    onecolumnlayout: 'one column layout',
    twocolumnlayout: 'two column layout',
    threecolumnlayout: 'three column layout',
    otherlayouts: 'Other layouts',
    wheelplot: 'Rotation chart',
    tabswitch: 'Tab switch',
    columnone: 'Column 1',
    column2: 'column 2',
    quickaccess: 'Quick entry',
    shortcutbutton: 'shortcut button',
    shortcutbuttonone: 'Shortcut button 1',
    shortcutbutton2: 'Shortcut button 2',
    graphic: 'Image & Text',
    announcements: 'Notice',
    statistics: 'Statistics',
    projectmanagement: 'project management',
    lanemap: 'Swimlane chart',
    embeddedurl: 'Embed URL',
    filesizemustnotexceed5mb: 'The file size must not exceed 5MB',
    image_empty: '[picture] content cannot be empty',
    slidesnumber_empty: '[rotation chart] quantity cannot be empty',
    slidescontent_empty: '[rotation chart] content cannot be empty',
    video_empty: '[Video] content cannot be empty',
    tabsnum_empty: '[tab switch] quantity cannot be empty',
    tabscontent_empty: '[tab switch] operation content cannot be empty',
    quickentrynum_empty: '[quick entry] quantity cannot be blank',
    quickentrycontent_empty: '[quick entry] the operation content cannot be empty',
    imagetextitem_empty: '[text] column name cannot be empty',
    imagetextcontent_empty: '[text] content source module cannot be empty',
    imagetexttitle_empty: '[text] title cannot be empty',
    imagetextimage_empty: '[text] picture cannot be empty',
    noticecontent_empty: '[announcement] the content source module cannot be empty',
    noticetitle_empty: '[announcement] title cannot be blank',
    noticecontent2_empty: '[announcement] content cannot be empty',
    viewnum_empty: '[view] quantity cannot be empty',
    chartname_empty: '[statistics] data analysis form name cannot be empty',
    chart_empty: '[statistics] chart cannot be empty',
    url_empty: '[embedded url] URL cannot be empty',
    sharepermissions: 'share permission',
    readonly: 'read-only',
    imagesettings: 'Picture settings',
    imagecontent: 'Picture content',
    linkaddress: 'Link address',
    picturetext: 'Picture text',
    imagedisplaymode: 'Picture display mode',
    rotationsset: 'Rotation chart setting',
    numberofrotationplots: 'Number of rotations',
    addupto5images: 'Add up to 5 pictures',
    videosettings: 'Video settings',
    videodisplay: 'video display',
    notitle: 'no title',
    withatitle: 'with a title',
    addvideo: 'Add video',
    videoaddress: 'Video address',
    localupload: 'Local upload',
    supporttencentyouku: 'Support Tencent, Youku video.',
    localvideo: 'Local video',
    videodisplaymode: 'Video display mode',
    tabtogglesettings: 'Tab switch settings',
    styleselection: 'Style selection',
    tabcolumn: 'Tab column',
    tabcolumnone: 'Tab column 1',
    tabcolumn2: 'Tab column 2',
    tabcolumn3: 'Tab column 3',
    tabswitchnumber: 'Number of tab switches',
    addupto10tabs: 'Add up to 10 tabs',
    shortcutentrysettings: 'Shortcut entry settings',
    shortcutstyle: 'Shortcut style',
    button: 'Button',
    entrance: 'entrance',
    singlebuttonwidth: 'Single button width',
    equal: 'Bisection',
    adaptivetext: 'Adaptive Text',
    backgroundcolor: 'background color',
    displaystyle: 'Presentation style',
    defaultstyle: 'Default style',
    adddivider: 'Dividing line',
    numberofrows: 'Single line quantity',
    addoperation: 'Add operation',
    graphicsettings: 'Graphic setting',
    columnname: 'Column name',
    displaytype: 'Display type',
    text: 'text',
    graphictypestructure: 'Graphic type structure',
    around: 'around',
    upanddown: 'Up and down',
    texttype: 'Text type',
    titlecontent: 'Title + content',
    displaycolumncount: 'Displays the number of columns',
    displayheight: 'Display height',
    graphicratio: 'Graphic proportion',
    textposition: 'Text position',
    totheleft: 'be at the left side',
    centered: 'center',
    totheright: 'be at the right side',
    graphiccontentsourcemodule: 'Graphic content source module',
    correspondingdisplayfield: 'Corresponding display field',
    announcementsettings: 'Announcement settings',
    banner: 'banner',
    panel: 'panel',
    runningupanddownthelantern: 'Up and down running lantern',
    runninghorselampleftandright: 'Left and right running lantern',
    showtitle: 'Show title',
    paneldisplay: 'Panel display',
    singledata: 'Single data',
    multipledata: 'Multiple data',
    bulletindisplaynumber: 'Number of announcements displayed',
    viewsettings: 'View settings',
    textdisplaystructure: 'Text display structure',
    singlecolumn: 'single column',
    doublecolumn: 'double columnl',
    statisticssettings: 'Statistics settings',
    dataanalysisformname: 'Data analysis form name',
    numericalappearanceadjustment: 'Value appearance adjustment',
    default: 'default',
    fontcolor: 'Font color',
    embeddedurlsettings: 'Embed URL settings',
    enterurl: 'Enter URL',
    schedulesettings: 'day setting',
    columnnamelocation: 'Column name location',
    displaycontent: 'Display content',
    swimlanemapsettings: 'Swimlane map settings',
    displaynumberofrows: 'Displays the number of rows',
    selectdata: 'Select data',
    addbutton: 'add button',
    performoperations: 'Perform the operation',
    operationcontent: 'Operation content',
    buttonname: 'Button name',
    icon: 'icon',
    newdata: 'New data',
    opensubmenu: 'Open submenu',
    openlink: 'Open link',
    repeatedsubmenu: 'Submenu repeated',
    datasourcecannotbenull: 'Data source cannot be empty',
    columnnamecannotbeempty: 'Column name cannot be empty',
    buttonnamecannotbeempty: 'Button name cannot be empty',
    linkaddresscannotbeempty: 'Link address cannot be empty',
    operationcontentcannotbeempty: 'Operation content cannot be empty',
    style1: 'Style 1',
    style2: 'Style 2',
    empty: 'empty',
    newtype: 'New type',
    createdIn: 'Created in',
    // 20210715
    deptask: 'Department task',
    degreeemergency: 'Emergency level',
    // 20220412
    lastmonth: 'last month',
    nextmonth: 'Next month',
    basicapplication: 'Basic Application',
    customapplication: 'Custom Application',
    welcomeunlockTF: 'Welcome to unlock',
    step1: 'Step1',
    step2: 'Step2',
    step3: 'Step3',
    step4: 'Step4',
    firstmeetTF: 'Firstmeet',
    whatcanTFdoforyou: 'What can do for you',
    learnabouttfapplication: 'learn about application',
    iftfapplicationbuilt: 'If you build a application',
    createfirstapplication: 'Create your first app',
    practicefromfield: 'Practice from field',
    howfindmyapp: 'How find my app',
    finishopeningpreviousstep: 'Finish opening previousstep',
    closeafterreading: 'Close after reading',
    field: '123123123',
    backlogData: 'Backlog data ',
    pendingTask: 'To be processed ',
    processedTask: 'Processed task ',
    toBeProcessed: 'To be processed ',
    pendingApprovalProcess: 'Pending ApprovalProcess ',
    businesstobeprocessed: 'Business process tobeprocessed ',
    attendanceTobeconfirmed: 'Attendance to beconfirmed ',
    pendingPerformanceReview: 'Performance appraisal to be processed',
    pendingPayrollPpproval: 'Pending salary approval ',
    customapptobeprocessed: 'Custom application tobeprocessed',
    owningModule: 'Owning module',
    nodeArrivalTime: 'Node arrival time',
    TaskStartEndTime: 'Task start and end time',
    confirmationDeadline: 'To confirm the deadline',
    assessmentName: 'Assessment name',
    assessor: 'Assessor',
    assessmentCycle: 'Assessment cycle',
    CurrentStage: 'Current stage',
    payName: 'Salary name',
    searchTitle: 'Search title',
    SearchTaskName: 'Search task name',
    SearchAttendanceName: 'Search for attendance name',
    SearchTestName: 'Search test name',
    SearchSalaryName: 'Search salary name',
    allDay: 'All-day',
    change: 'Change',
    customRepeat: 'Custom Time',
    repeatTate: 'Repetition rate',
    endRepeat: 'End repetition',
    notRepeat: 'Never',
    everyDayRepeat: 'Every Workday',
    limitedDegree: 'Limited degree',
    neverEnd: 'Never end',
    repeatTateNotEmpty: 'The repetition rate cannot be empty',
    repeatTateError: 'The repetition frequency format is incorrect',
    deadlineNotEmpty: 'The cut-off time cannot be empty',
    degreeEmpty: 'The qualified degree cannot be empty',
    degreeError: 'The limited frequency format is incorrect',
    deleteBacklog: 'Are you sure you want to delete this backlog?',
    batchDelete: 'Batch deletion',
    cutomAppTips:
      "It is only used for the front-end [custom application] to delete the to-do data, after deletion, the responsible person's to-do items will not be displayed, this operation is not recoverable (other types of to-do data are synchronized with the data in real time, from the original data processing).",
    schedule: 'Event',
    effectiveTime: 'Effective time',
    every: 'Every',
    everyWorkingDay: 'Every working day',
    mondayToFriday: 'Monday to Friday',
    terminationRepeat: 'Termination repeat',
    pleaseInputPhoneNo: 'Please enter the phone number',
    noDataFound: 'No data found',
    searching: 'Searching...'
  }
}
